import { Component, inject } from '@angular/core';
import { COMPONENT_VERSIONS } from '@fgb/core';
import { EventsPageV2Component } from './events-page-v2/events-page-v2.component';
import { EventsPageV1Component } from './events-page-v1/events-page-v1.component';

const componentMap = {
  1: EventsPageV1Component,
  2: EventsPageV2Component,
};

type MarketplaceComponentVersion = keyof typeof componentMap;

@Component({
  selector: 'fgb-events-page',
  template: `<ng-container *ngComponentOutlet="component"></ng-container>`,
})
export class EventsPageComponent {
  private readonly marketplaceVersion = inject(COMPONENT_VERSIONS)?.marketplace as MarketplaceComponentVersion;

  get component() {
    return componentMap[this.marketplaceVersion || 1]; // default to version 1 if not specified
  }
}
